import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import { CircularProgress } from '@material-ui/core';
import axios from 'axios';

export default function OrderDetailPdfDownloadButton({
	pedido,
	children = 'Descargar PDF Completo',
	...buttonAttrs
}) {
	const [loading, setLoading] = useState(false);

	const handleDownloadPDF = async () => {
		if (!pedido || !pedido.ID) {
			alert('No se puede generar el PDF. Información del pedido incompleta.');
			return;
		}

		try {
			setLoading(true);

			const response = await axios.post(
				'/api/pdf/order',
				{
					SUPEDIDO: pedido.ID,
				},
				{
					responseType: 'blob',
					withCredentials: true,
				}
			);

			if (!response.data) {
				throw new Error('Error al generar el PDF');
			}

			const blob = new Blob([response.data], { type: 'application/pdf' });
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.target = '_blank';
			a.rel = 'noopener noreferrer';
			a.style.display = 'none';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Error al generar PDF del pedido:', error.message);
			if (error.code === 'ECONNABORTED') {
				alert(
					'Tiempo de espera agotado. El PDF no se pudo generar. Intenta de nuevo.'
				);
			} else {
				alert(
					'No se pudo generar el PDF del pedido. Por favor, intenta de nuevo más tarde.'
				);
			}
		} finally {
			setLoading(false);
		}
	};

	const isDisabled = !pedido || !pedido.ID || loading;

	buttonAttrs = {
		color: 'primary',
		variant: 'contained',
		startIcon: loading ? <CircularProgress size={'1rem'} /> : <GetAppIcon />,
		...buttonAttrs,
	};

	return (
		<Button {...buttonAttrs} onClick={handleDownloadPDF} disabled={isDisabled}>
			{loading ? 'Generando PDF...' : children}
		</Button>
	);
}

